<template>
  <el-form :model="data" class="activity-review activity-review-followup">
    <div class="activity-review__info">
      <review-info-box :rfq-type="data.rfqTypeTitle" :company="data.customerCompanyName" :po="data.po" :partNumber="data.partNumber" :partSN="data.partSN" />
    </div>
    <div class="activity-review__boxes">
      <div class="row mx-0">
        <div class="col-xl-4 col-6">
          <div class="activity-review__box" :class="classOrderPhase">
            <el-form-item
              :label="L10n('order-phase')"
              prop="orderPhase"
              class="material-style"
            >
              <select-response
                :model.sync="form.orderPhaseID"
                @on-change="(id, data) => autoSave('orderPhaseID', { label: data && data.title })"
                :isLoading="dataSourceOrderPhase.loading"
                :data="dataSourceOrderPhase.records"
              ></select-response>
            </el-form-item>
          </div>
        </div>
        <div class="col-xl-3 col-6">
          <div class="activity-review__box" :class="classExchAgreementSigned">
            <el-form-item
                prop="exchAgreementSigned"
                :label="L10n('exch-agreement-signed')"
                class="material-style"
                data-filed="true"
              >
                <el-checkbox
                  v-model="form.exchAgreementSigned"
                  @change="autoSave('exchAgreementSigned')"
                >
                </el-checkbox>
              </el-form-item>
          </div>
        </div>
        <div class="col-xl-3 col-6">
          <div class="activity-review__box" :class="classUnitShipped">
            <el-form-item
                prop="unitShipped"
                :label="L10n('unit-shipped')"
                class="material-style"
                data-filed="true"
              >
                <el-checkbox
                  v-model="form.unitShipped"
                  @change="autoSave('unitShipped')"
                >
                </el-checkbox>
              </el-form-item>
          </div>
        </div>
        <div class="col-xl-2 col-6">
          <div class="activity-review__box" :class="classCoreReceived">
            <el-form-item
              prop="coreReceived"
              :label="L10n('core-received')"
              class="material-style"
              data-filed="true"
            >
              <el-checkbox
                v-model="form.coreReceived"
                @change="autoSave('coreReceived')"
              >
              </el-checkbox>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
    <div class="activity-review__control">
      <ui-button
        style="height: 100%"
        class="btn btn-size-s"
        :label="L10n('details')"
        isVertical
        @click="$emit('onDetails')"
      />
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'ActivityReviewForm',
  mixins: [Form],
  components: {
    'review-info-box': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Activity/ReviewInfoBox')
  },
  computed: {
    dataSourceOrderPhase () {
      return this.API('orderPhases/GetAllDynamic?select=id,title&filter=!title.startsWith("Z_")&orderBy=title')
    },
    sourceStandBy () {
      return [
        { id: 'sourcing-parts', title: this.L10n('sourcing-parts') },
        { id: 'standby', title: this.L10n('standby') },
        { id: 'pending-payment', title: this.L10n('pending-payment') }
      ]
    },
    classPriority () {
      let priority = this.dataSourcePriority.map[this.form.priorityID]
      return {
        'color-red': priority && priority.isCritical
      }
    },
    classOrderPhase () {
      return {
        'bg-orange': this.form.orderPhaseID !== 29
      }
    },
    classExchAgreementSigned () {
      return {
        'bg-green': !!this.form.exchAgreementSigned
      }
    },
    classUnitShipped () {
      return {
        'bg-green': !!this.form.unitShipped
      }
    },
    classCoreReceived () {
      return {
        'bg-green': !!this.form.coreReceived
      }
    }
  }
}
</script>
<style lang="stylus">
  .activity-review-followup{
    .activity-review__info {
      min-width 30rem;
    }
    .el-form-item{
      width: 90%;
    }
  }
</style>
